export const MeetingState_Consumer_Payment = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/consumer/payment.html';

        $scope.showCancel = false;

        $scope.consumerCost = $scope.meeting.get('consumerCost');
    },
];
